module.exports = __webpack_public_path__ + "img/RECEIVE.3cf38f54.svg";